<template>
    <div class="form-container">
        <form @submit.prevent v-if="codeStatus">
            <p>Please enter your email for reset password. A code you will be send.</p>

            <input v-model="email" type="email" placeholder="Email adress">

            <div v-if="badCredentialsMessage" class="invalidCredentials">
                Invalid credentials
            </div>
            <button :class="{loading}">Request code</button>

            <div class="actions">
                <p @click="codeStatus = !codeStatus">I have a code</p>
            </div>
        </form>
        <form @submit.prevent v-else>
            <p>Please enter the code in the email you receive. Code will be valid 24h</p>

            <input v-model="code" type="text"  placeholder="Code">

            <div v-if="badCredentialsMessage" class="invalidCredentials">
                Invalid credentials
            </div>
            <button :class="{loading}">Next</button>

            <div class="actions">
                <p @click="codeStatus = !codeStatus">I don't have a code</p>
            </div>
        </form>
    </div>

</template>

<script>
    export default {
        name: "LostPassword",

        data() {
            return {
                codeStatus: true
            }
        }
    }
</script>

<style scoped lang="scss">
    form{
        width: 500px;
        margin: 100px auto auto;
        border: 2px solid var(--main-green);
        border-radius: 2px;
        padding: 40px 20px 20px;
        color: white;

        p{
            color: black;
        }

        input[type="email"], input[type="text"] {
            font-size: 14px;
            display: block;
            width: 60%;
            height: 30px;
            margin: auto auto 15px;
            border: 1px solid;
            border-radius: 2px;
            padding: 3px;
        }

        button{
            font-size: 15px;
            font-weight: 700;
            display: block;
            width: 60%;
            margin: auto;
            border: 0;
            border-radius: 3px;
            padding: 5px;
            color: white;
            background-color: black;
            cursor: pointer;
        }

        .actions{
            font-size: 14px;
            margin-top: 20px;

            a{
                display: block;
                color: #000;
                text-align: left;

                &:last-of-type{
                    margin-top: 10px;
                }
            }
        }
    }
</style>

